export default function About() {
  return (
    <section id="about" className="py-32 bg-[#F8F7F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-5 gap-12">
          {/* Left Column */}
          <div className="col-span-2 pt-12">
            <div className="text-xs tracking-widest text-[#FF6B4A] font-semibold mb-6 uppercase">
              Who We Are
            </div>
            <h2 className="text-6xl font-serif text-[#2A2A2A] mb-12 leading-tight">
              Dedicated iOS Development Experts
            </h2>
            <p className="text-lg text-[#6B6B6B] leading-relaxed">
              JUMI S.R.L. is a team of passionate developers and designers committed to creating exceptional iOS applications. We specialize in building secure, efficient, and user-friendly mobile solutions that enhance the digital experience for millions of users worldwide.
            </p>
            <p className="text-lg text-[#6B6B6B] leading-relaxed mt-6">
              Our expertise spans across security applications, system optimization tools, and innovative mobile utilities. Every product we create is crafted with meticulous attention to detail and a deep understanding of user needs.
            </p>
          </div>

          {/* Right Column */}
          <div className="col-span-3">
            <div className="bg-[#1A1A1A] rounded-[32px] p-12 shadow-xl relative overflow-hidden">
              {/* Decorative Pattern */}
              <div className="absolute top-0 right-0 w-64 h-64 opacity-10">
                <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-full blur-3xl"></div>
              </div>

              {/* Established Badge */}
              <div className="inline-block px-6 py-2 rounded-full bg-white/20 text-white text-sm font-medium mb-12">
                ESTABLISHED 2020
              </div>

              {/* Product Highlights */}
              <div className="space-y-12 relative z-10">
                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#4A90E2] to-[#50E3C2] flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-3">VPN Protection</h3>
                    <p className="text-gray-300 leading-relaxed">
                      Enterprise-grade VPN solution providing secure, encrypted connections for iOS users. Protect your privacy and browse safely with our advanced security protocols and global server network.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#FF6B4A] to-[#FFB347] flex items-center justify-center flex-shrink-0">
                    <i className="ri-brush-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-3">System Cleaner</h3>
                    <p className="text-gray-300 leading-relaxed">
                      Powerful optimization tool that keeps your iOS device running smoothly. Remove junk files, optimize storage, and boost performance with intelligent cleaning algorithms.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
